// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QkRy","textarea":"styles_textarea__5HldK"};